var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":_vm.vipId>0?'店铺二维码':'分享店铺'}}),_c('shopqr',{attrs:{"qr_url":_vm.followShop.src,"shop_name":_vm.followShop.name,"shop_tel":_vm.followShop.shop_tel,"shop_address":_vm.followShop.shop_address}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }